<template>
  <b-container class="mw-100 px-0">
    <BDXValidationReport />
  </b-container>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import BDXValidationReport from '@components/BDXValidationReport'

export default defineComponent({
  name: 'BDXValidationReportPage',
  components: {
    BDXValidationReport
  }
})
</script>
